<template>
  <div class="driver-task-container">
    <!-- 地图选点组件 -->
    <LocationPicker
      :visible.sync="locationPickerVisible"
      :title="locationPickerTitle"
      :center="locationPickerCenter"
      @select="onLocationSelected"
    />

    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">接送任务管理</span>
      </div>
      <el-button type="primary" size="small" @click="handleCreate">
        <i class="el-icon-plus"></i> 创建任务
      </el-button>
    </div>

    <!-- 标签页 -->
    <el-tabs v-model="activeTab" class="main-tabs" @tab-change="handleTabChange">
      <!-- 任务列表标签页 -->
      <el-tab-pane label="任务列表" name="task">
        <div class="search-bar">
          <el-input placeholder="任务编号/学员电话" v-model="searchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="handleSearch">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
          <el-select v-model="searchForm.taskType" placeholder="任务类型" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
            <el-option label="车站接学员" value="STATION_PICKUP" />
            <el-option label="基地到考场" value="BASE_TO_EXAM" />
            <el-option label="考场回基地" value="EXAM_TO_BASE" />
          </el-select>
          <el-select v-model="searchForm.taskStatus" placeholder="任务状态" clearable style="width: 130px; margin-left: 10px;" @change="handleSearch">
            <el-option label="待接单" value="PENDING" />
            <el-option label="已接单" value="ACCEPTED" />
            <el-option label="已接到" value="PICKED" />
            <el-option label="已送达" value="ARRIVED" />
            <el-option label="已取消" value="CANCELLED" />
          </el-select>
          <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
            <i class="el-icon-search"></i> 查询
          </el-button>
          <el-button @click="handleReset" style="margin-left: 10px;">
            <i class="el-icon-refresh"></i> 重置
          </el-button>
        </div>

        <!-- 统计卡片 -->
        <div class="stats-cards">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon pending"><i class="el-icon-time"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.pending }}</div>
                  <div class="stat-label">待接单</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon accepted"><i class="el-icon-check"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.accepted }}</div>
                  <div class="stat-label">进行中</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon arrived"><i class="el-icon-circle-check"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.arrived }}</div>
                  <div class="stat-label">已完成</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon cancelled"><i class="el-icon-close"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ statsOverview.cancelled }}</div>
                  <div class="stat-label">已取消</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          border
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        >
          <el-table-column prop="taskNo" label="任务编号" width="150" />
          <el-table-column prop="taskTypeName" label="任务类型" width="110">
            <template slot-scope="scope">
              <el-tag size="small" :type="getTaskTypeTag(scope.row.taskType)">
                {{ scope.row.taskTypeName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="studentName" label="学员姓名" width="100" />
          <el-table-column prop="studentPhone" label="学员电话" width="120" />
          <el-table-column prop="driverUserName" label="司机" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.driverUserName">{{ scope.row.driverUserName }}</span>
              <span v-else class="no-assign">待指派</span>
            </template>
          </el-table-column>
          <el-table-column prop="scheduledTime" label="计划时间" width="160" />
          <el-table-column prop="pickupLocation" label="接人地点" width="200">
            <template slot-scope="scope">
              {{ scope.row.pickupLocation }}{{ scope.row.pickupAddressDetail ? ' ' + scope.row.pickupAddressDetail : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="arrivalLocation" label="送达地点" width="200">
            <template slot-scope="scope">
              {{ scope.row.arrivalLocation }}{{ scope.row.arrivalAddressDetail ? ' ' + scope.row.arrivalAddressDetail : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="taskStatusName" label="状态" width="90">
            <template slot-scope="scope">
              <el-tag size="small" :type="getStatusTagType(scope.row.taskStatus)">
                {{ scope.row.taskStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160" />
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="handleEdit(scope.row)" v-if="scope.row.taskStatus === 'PENDING'">编辑</el-button>
              <el-button type="text" size="small" @click="handleDelete(scope.row)" v-if="scope.row.taskStatus === 'PENDING'" style="color: #f56c6c;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper">
          <span class="total-text">共 {{ total }} 条记录</span>
          <el-pagination
            background
            layout="sizes, prev, pager, next"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </el-tab-pane>

      <!-- 行程记录标签页 -->
      <el-tab-pane label="行程记录" name="trip">
        <div class="search-bar">
          <el-input placeholder="关键词" v-model="tripSearchForm.keyword" style="width: 150px;" clearable @keyup.enter.native="loadTripRecords">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
          <el-select v-model="tripSearchForm.tripType" placeholder="行程类型" clearable style="width: 130px; margin-left: 10px;">
            <el-option label="接人" value="PICKUP" />
            <el-option label="运送" value="TRANSPORT" />
          </el-select>
          <el-button type="primary" @click="loadTripRecords" style="margin-left: 10px;">
            <i class="el-icon-search"></i> 查询
          </el-button>
        </div>

        <el-table
          v-loading="tripLoading"
          :data="tripData"
          stripe
          border
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        >
          <el-table-column prop="tripNo" label="行程编号" width="150" />
          <el-table-column prop="taskNo" label="关联任务" width="150" />
          <el-table-column prop="driverUserName" label="司机" width="100" />
          <el-table-column prop="studentName" label="学员" width="100" />
          <el-table-column prop="tripTypeName" label="行程类型" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.tripType === 'PICKUP' ? 'primary' : 'success'">
                {{ scope.row.tripTypeName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="startLocation" label="起点" width="150" show-overflow-tooltip />
          <el-table-column prop="endLocation" label="终点" width="150" show-overflow-tooltip />
          <el-table-column prop="startTime" label="出发时间" width="160" />
          <el-table-column prop="endTime" label="到达时间" width="160" />
          <el-table-column prop="distance" label="里程(km)" width="100" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleViewTrip(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper">
          <span class="total-text">共 {{ tripTotal }} 条记录</span>
          <el-pagination
            background
            layout="sizes, prev, pager, next"
            :current-page="tripPagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tripPagination.pageSize"
            :total="tripTotal"
            @size-change="handleTripSizeChange"
            @current-change="handleTripPageChange"
          />
        </div>
      </el-tab-pane>

      <!-- 接送统计标签页 -->
      <el-tab-pane label="接送统计" name="stats">
        <!-- 统计卡片 -->
        <div class="stats-cards">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon total"><i class="el-icon-s-data"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ driverStats.totalTrips }}</div>
                  <div class="stat-label">总行程数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon distance"><i class="el-icon-map-location"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ driverStats.totalDistance }}</div>
                  <div class="stat-label">总里程(km)</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon students"><i class="el-icon-user"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ driverStats.totalStudents }}</div>
                  <div class="stat-label">接送学员数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="stat-card">
                <div class="stat-icon timeout"><i class="el-icon-warning"></i></div>
                <div class="stat-info">
                  <div class="stat-value">{{ driverStats.timeoutCount }}</div>
                  <div class="stat-label">超时次数</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="section-title">
          <i class="el-icon-s-data"></i> 司机接送排行
        </div>

        <el-table
          v-loading="statsLoading"
          :data="driverStatsList"
          stripe
          border
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
        >
          <el-table-column prop="rank" label="排名" width="80" type="index" />
          <el-table-column prop="driverUserName" label="司机" width="120" />
          <el-table-column prop="tripCount" label="行程数" width="100" />
          <el-table-column prop="totalDistance" label="总里程(km)" width="120" />
          <el-table-column prop="studentCount" label="接送学员数" width="120" />
          <el-table-column prop="timeoutCount" label="超时次数" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.timeoutCount > 0" style="color: #f56c6c;">{{ scope.row.timeoutCount }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column prop="avgDuration" label="平均时长(分钟)" width="130" />
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 创建/编辑任务弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="taskForm" :model="taskForm" :rules="taskRules" label-width="100px">
        <el-form-item label="任务类型" prop="taskType">
          <el-select v-model="taskForm.taskType" placeholder="请选择" style="width: 100%">
            <el-option label="车站接学员" value="STATION_PICKUP" />
            <el-option label="基地到考场" value="BASE_TO_EXAM" />
            <el-option label="考场回基地" value="EXAM_TO_BASE" />
          </el-select>
        </el-form-item>
        <el-form-item label="学员" prop="studentId">
          <el-select v-model="taskForm.studentId" placeholder="请选择学员" filterable style="width: 100%">
            <el-option v-for="s in studentList" :key="s.id" :label="s.studentName + ' - ' + s.contactPhone" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="司机" prop="driverUserId">
          <el-select v-model="taskForm.driverUserId" placeholder="请选择司机" filterable style="width: 100%">
            <el-option v-for="d in driverList" :key="d.id" :label="d.name" :value="d.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="计划时间" prop="scheduledTime">
          <el-date-picker v-model="taskForm.scheduledTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
        </el-form-item>
        <el-form-item label="接人地点" prop="pickupLocation">
          <div class="location-input-group">
            <el-input v-model="taskForm.pickupLocation" placeholder="请选择或输入接人地点" style="flex: 1;" />
            <el-button type="primary" size="small" @click="openLocationPicker('pickup')" style="margin-left: 8px;">
              <i class="el-icon-location"></i> 地图选点
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-input v-model="taskForm.pickupAddressDetail" placeholder="补充门牌号等信息" style="width: 300px;" />
        </el-form-item>
        <el-form-item label="送达地点" prop="arrivalLocation">
          <div class="location-input-group">
            <el-input v-model="taskForm.arrivalLocation" placeholder="请选择或输入送达地点" style="flex: 1;" />
            <el-button type="primary" size="small" @click="openLocationPicker('arrival')" style="margin-left: 8px;">
              <i class="el-icon-location"></i> 地图选点
            </el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-input v-model="taskForm.arrivalAddressDetail" placeholder="补充门牌号等信息" style="width: 300px;" />
        </el-form-item>
        <el-form-item label="车次/航班">
          <el-input v-model="taskForm.trainNo" placeholder="请输入车次或航班号" />
        </el-form-item>
        <el-form-item label="学员电话">
          <el-input v-model="taskForm.studentPhone" placeholder="请输入学员联系电话" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="任务详情" :visible.sync="viewDialogVisible" width="700px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="任务编号">{{ viewData.taskNo }}</el-descriptions-item>
        <el-descriptions-item label="任务类型">
          <el-tag :type="getTaskTypeTag(viewData.taskType)">{{ viewData.taskTypeName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="学员姓名">{{ viewData.studentName }}</el-descriptions-item>
        <el-descriptions-item label="学员电话">{{ viewData.studentPhone }}</el-descriptions-item>
        <el-descriptions-item label="司机">{{ viewData.driverUserName || '待指派' }}</el-descriptions-item>
        <el-descriptions-item label="任务状态">
          <el-tag :type="getStatusTagType(viewData.taskStatus)">{{ viewData.taskStatusName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="计划时间">{{ viewData.scheduledTime }}</el-descriptions-item>
        <el-descriptions-item label="车次/航班">{{ viewData.trainNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="接人地点">{{ viewData.pickupLocation }}{{ viewData.pickupAddressDetail ? ' ' + viewData.pickupAddressDetail : '' }}</el-descriptions-item>
        <el-descriptions-item label="送达地点">{{ viewData.arrivalLocation }}{{ viewData.arrivalAddressDetail ? ' ' + viewData.arrivalAddressDetail : '' }}</el-descriptions-item>
        <el-descriptions-item label="接单时间">{{ viewData.acceptTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="接到时间">{{ viewData.pickupTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="送达时间">{{ viewData.arrivalTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ viewData.createTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 行程详情弹窗 -->
    <el-dialog title="行程详情" :visible.sync="tripViewDialogVisible" width="600px">
      <el-descriptions :column="1" border v-if="tripViewData">
        <el-descriptions-item label="行程编号">{{ tripViewData.tripNo }}</el-descriptions-item>
        <el-descriptions-item label="行程类型">
          <el-tag :type="tripViewData.tripType === 'PICKUP' ? 'primary' : 'success'">
            {{ tripViewData.tripTypeName }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="关联任务">{{ tripViewData.taskNo }}</el-descriptions-item>
        <el-descriptions-item label="司机">{{ tripViewData.driverUserName }}</el-descriptions-item>
        <el-descriptions-item label="学员">{{ tripViewData.studentName }}</el-descriptions-item>
        <el-descriptions-item label="起点">
          {{ tripViewData.startLocation }}{{ tripViewData.startLocationDetail ? ' ' + tripViewData.startLocationDetail : '' }}
        </el-descriptions-item>
        <el-descriptions-item label="终点">
          {{ tripViewData.endLocation }}{{ tripViewData.endLocationDetail ? ' ' + tripViewData.endLocationDetail : '' }}
        </el-descriptions-item>
        <el-descriptions-item label="出发时间">{{ tripViewData.startTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="到达时间">{{ tripViewData.endTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="行驶里程">{{ tripViewData.distance ? tripViewData.distance + ' km' : '-' }}</el-descriptions-item>
        <el-descriptions-item label="行程时长">{{ tripViewData.duration ? tripViewData.duration + ' 分钟' : '-' }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="tripViewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as driverApi from '@/api/driverApi.js'
import LocationPicker from '@/components/common/LocationPicker.vue'

export default {
  name: 'DriverTaskManage',
  components: { LocationPicker },
  data() {
    return {
      activeTab: 'task',
      searchForm: {
        keyword: '',
        taskType: '',
        taskStatus: ''
      },
      statsOverview: {
        pending: 0,
        accepted: 0,
        arrived: 0,
        cancelled: 0
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0,

      dialogVisible: false,
      dialogTitle: '创建任务',
      taskForm: {
        taskType: '',
        studentId: null,
        driverUserId: null,
        scheduledTime: '',
        pickupLocation: '',
        pickupLat: null,
        pickupLng: null,
        pickupAddressDetail: '',
        arrivalLocation: '',
        arrivalLat: null,
        arrivalLng: null,
        arrivalAddressDetail: '',
        trainNo: '',
        studentPhone: ''
      },
      taskRules: {
        taskType: [{ required: true, message: '请选择任务类型', trigger: 'change' }],
        studentId: [{ required: true, message: '请选择学员', trigger: 'change' }],
        scheduledTime: [{ required: true, message: '请选择计划时间', trigger: 'change' }],
        pickupLocation: [{ required: true, message: '请选择或输入接人地点', trigger: 'change' }],
        arrivalLocation: [{ required: true, message: '请选择或输入送达地点', trigger: 'change' }]
      },
      submitLoading: false,
      editId: null,

      studentList: [],
      driverList: [],

      viewDialogVisible: false,
      viewData: null,

      // 行程详情弹窗
      tripViewDialogVisible: false,
      tripViewData: null,

      // 行程记录相关
      tripSearchForm: {
        keyword: '',
        tripType: ''
      },
      tripData: [],
      tripLoading: false,
      tripPagination: {
        page: 1,
        pageSize: 20
      },
      tripTotal: 0,

      // 接送统计相关
      driverStats: {
        totalTrips: 0,
        totalDistance: 0,
        totalStudents: 0,
        timeoutCount: 0
      },
      driverStatsList: [],
      statsLoading: false,

      // 地图选点相关
      locationPickerVisible: false,
      locationPickerTitle: '选择位置',
      locationPickerCenter: { lat: 30.572816, lng: 114.27719 },
      currentLocationType: null // 'pickup' | 'arrival'
    }
  },
  created() {
    // 从路由参数读取初始标签页
    const tab = this.$route.query.tab
    if (tab && ['task', 'trip', 'stats'].includes(tab)) {
      this.activeTab = tab
    }
    this.loadData()
    this.loadStats()
    this.loadStudentList()
    this.loadDriverList()
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newTab) {
        if (newTab === 'trip') {
          this.loadTripRecords()
        } else if (newTab === 'stats') {
          this.loadDriverStats()
        }
      }
    }
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    handleTabChange(tab) {
      if (tab === 'trip') {
        this.loadTripRecords()
      } else if (tab === 'stats') {
        this.loadDriverStats()
      }
    },
    async loadStats() {
      try {
        const result = await driverApi.getTaskStatistics()
        if (result) {
          this.statsOverview = {
            pending: result.pending || 0,
            accepted: (result.accepted || 0) + (result.picked || 0),
            arrived: result.arrived || 0,
            cancelled: result.cancelled || 0
          }
        }
      } catch (e) {
        console.error('加载统计数据失败', e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        const result = await driverApi.getTaskList(params)
        if (result) {
          this.tableData = result.list || []
          this.total = result.total || 0
        }
      } catch (e) {
        console.error('加载任务数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadStudentList() {
      try {
        const result = await driverApi.getStudentSelectList()
        if (result && result.list) {
          this.studentList = result.list.map(item => ({
            id: item.id,
            studentName: item.studentName,
            contactPhone: item.contactPhone || item.phone
          }))
        }
      } catch (e) {
        console.error('加载学员列表失败', e)
      }
    },
    async loadDriverList() {
      try {
        const result = await driverApi.getDriverList()
        if (result) {
          this.driverList = result.map(item => ({
            id: item.userId,
            name: item.nickName || item.userName
          }))
        }
      } catch (e) {
        console.error('加载司机列表失败', e)
      }
    },
    // 行程记录相关方法
    async loadTripRecords() {
      this.tripLoading = true
      try {
        const params = {
          keyword: this.tripSearchForm.keyword,
          tripType: this.tripSearchForm.tripType,
          page: this.tripPagination.page,
          pageSize: this.tripPagination.pageSize
        }
        const result = await driverApi.getMyTripList(params)
        if (result) {
          this.tripData = result.list || []
          this.tripTotal = result.total || 0
        }
      } catch (e) {
        console.error('加载行程记录失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.tripLoading = false
      }
    },
    handleTripSizeChange(val) {
      this.tripPagination.pageSize = val
      this.loadTripRecords()
    },
    handleTripPageChange(val) {
      this.tripPagination.page = val
      this.loadTripRecords()
    },
    handleViewTrip(row) {
      this.tripViewData = row
      this.tripViewDialogVisible = true
    },
    // 接送统计相关方法
    async loadDriverStats() {
      this.statsLoading = true
      try {
        const result = await driverApi.getDriverStats()
        if (result) {
          this.driverStats = {
            totalTrips: result.totalTrips || 0,
            totalDistance: result.totalDistance || 0,
            totalStudents: result.totalStudents || 0,
            timeoutCount: result.timeoutCount || 0
          }
          this.driverStatsList = result.driverList || []
        }
      } catch (e) {
        console.error('加载统计数据失败', e)
      } finally {
        this.statsLoading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        keyword: '',
        taskType: '',
        taskStatus: ''
      }
      this.pagination.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    handleCreate() {
      this.dialogTitle = '创建任务'
      this.editId = null
      this.taskForm = {
        taskType: '',
        studentId: null,
        driverUserId: null,
        scheduledTime: '',
        pickupLocation: '',
        pickupLat: null,
        pickupLng: null,
        arrivalLocation: '',
        arrivalLat: null,
        arrivalLng: null,
        trainNo: '',
        studentPhone: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑任务'
      this.editId = row.id
      this.taskForm = {
        taskType: row.taskType,
        studentId: row.studentId,
        driverUserId: row.driverUserId,
        scheduledTime: row.scheduledTime,
        pickupLocation: row.pickupLocation,
        pickupLat: row.pickupLat,
        pickupLng: row.pickupLng,
        pickupAddressDetail: row.pickupAddressDetail || '',
        arrivalLocation: row.arrivalLocation,
        arrivalLat: row.arrivalLat,
        arrivalLng: row.arrivalLng,
        arrivalAddressDetail: row.arrivalAddressDetail || '',
        trainNo: row.trainNo,
        studentPhone: row.studentPhone
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      try {
        this.submitLoading = true
        if (this.editId) {
          await driverApi.updateTask(this.editId, this.taskForm)
          this.$message.success('更新成功')
        } else {
          await driverApi.createTask(this.taskForm)
          this.$message.success('创建成功')
        }
        this.dialogVisible = false
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      } finally {
        this.submitLoading = false
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该任务吗？', '提示', {
          type: 'warning'
        })
        await driverApi.deleteTask(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error(e.message || '删除失败')
        }
      }
    },
    async handleView(row) {
      try {
        const result = await driverApi.getTaskDetail(row.id)
        this.viewData = result
        this.viewDialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    getTaskTypeTag(type) {
      const map = {
        'STATION_PICKUP': 'primary',
        'BASE_TO_EXAM': 'success',
        'EXAM_TO_BASE': 'warning'
      }
      return map[type] || ''
    },
    getStatusTagType(status) {
      const map = {
        'PENDING': 'warning',
        'ACCEPTED': 'primary',
        'PICKED': 'success',
        'ARRIVED': 'info',
        'CANCELLED': 'danger'
      }
      return map[status] || ''
    },
    // ========== 地图选点相关 ==========
    openLocationPicker(type) {
      this.currentLocationType = type
      this.locationPickerTitle = type === 'pickup' ? '选择接人位置' : '选择送达位置'
      // 如果已有经纬度，以当前位置为中心
      if (type === 'pickup' && this.taskForm.pickupLat && this.taskForm.pickupLng) {
        this.locationPickerCenter = {
          lat: this.taskForm.pickupLat,
          lng: this.taskForm.pickupLng
        }
      } else if (type === 'arrival' && this.taskForm.arrivalLat && this.taskForm.arrivalLng) {
        this.locationPickerCenter = {
          lat: this.taskForm.arrivalLat,
          lng: this.taskForm.arrivalLng
        }
      }
      this.locationPickerVisible = true
    },
    onLocationSelected(location) {
      if (this.currentLocationType === 'pickup') {
        this.taskForm.pickupLocation = location.address
        this.taskForm.pickupLat = location.latitude
        this.taskForm.pickupLng = location.longitude
      } else if (this.currentLocationType === 'arrival') {
        this.taskForm.arrivalLocation = location.address
        this.taskForm.arrivalLat = location.latitude
        this.taskForm.arrivalLng = location.longitude
      }
      this.currentLocationType = null
    }
  }
}
</script>

<style scoped>
.driver-task-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.main-tabs {
  margin: 15px 20px;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.stats-cards {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  border: 1px solid #ebeef5;
}

.stat-card .stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 16px;
}

.stat-card .stat-icon.pending { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.stat-card .stat-icon.accepted { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.stat-card .stat-icon.arrived { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.cancelled { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }
.stat-card .stat-icon.total { background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%); }
.stat-card .stat-icon.distance { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card .stat-icon.students { background: linear-gradient(135deg, #9c27b0 0%, #ba68c8 100%); }
.stat-card .stat-icon.timeout { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }

.stat-card .stat-info .stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.stat-card .stat-info .stat-label {
  font-size: 14px;
  color: #909399;
}

.section-title {
  font-weight: bold;
  margin-bottom: 16px;
  color: #303133;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
}

.section-title i {
  margin-right: 8px;
  color: #409eff;
}

.el-table {
  background: #fff;
  border-radius: 4px;
}

.no-assign {
  color: #909399;
  font-style: italic;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-top: 15px;
}

.total-text {
  font-size: 14px;
  color: #606266;
}

/* 地图选点输入框样式 */
.location-input-group {
  display: flex;
  align-items: center;
}
</style>
